import { StyleSheet, Text, TouchableOpacity } from "react-native";
import Icon from "react-native-vector-icons/MaterialCommunityIcons";
import * as Colors from "../../../styles/colors";
import * as Fonts from "../../../styles/typography";
import FeatherIcon from "react-native-vector-icons/Feather";

export default function ButtonWallet({
  iconName,
  backgroundColor,
  onPress,
  text,
  size,
  iconType = "materialcommunity"
}) {
  return (
    <TouchableOpacity
      style={[styles.buttonView, { backgroundColor: backgroundColor, width: size }]}
      onPress={onPress}
    >
      {iconType == "feather" ? <FeatherIcon name={iconName} size={48} color={Colors.WHITE} />
        : <Icon name={iconName} size={48} color={Colors.WHITE} />}
      <Text adjustsFontSizeToFit={true} numberOfLines={1} style={styles.buttonText}>{text}</Text>
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  buttonView: {
    borderRadius: 8,
    alignItems: "center",
    justifyContent: "center",
    padding: 8,
    marginHorizontal: 4,
    marginVertical: 4,
    shadowColor: Colors.BLACK,
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
  },
  buttonText: {
    color: Colors.WHITE,
    fontSize: Fonts.FONT_SIZE_16,
    fontWeight: "500",
  },
});
